import { styled, Grid } from '@mui/material';
import { Box } from '@mui/material';

interface ContentGridProps {
  smScreen?: boolean;
}
export const ContentGrid = styled(Grid, {
  shouldForwardProp: (prop) => prop !== 'smScreen',
})<ContentGridProps>(({ theme, smScreen }) => ({
  marginLeft: smScreen ? 0 : theme.spacing(5),
  display: 'grid',
  gridTemplateColumns: 'repeat(1, 1fr)',
  height: '100%',
  alignItems: 'center',

  [theme.breakpoints.down('sm')]: {
    marginLeft: 0,
  },
}));
